import { loginFormModel } from "./loginFormModel";

const {
  formField: { email, password },
} = loginFormModel;
export const loginInitialValues = {
  [email.name]: "",
  [password.name]: "",
};
